import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Paper, Typography } from '@material-ui/core';

const Instructions = ({ classes, version }) => {
  return (
    <Grid item xs={12} align="left">
      <section align="left" className={classes.sectionTitle}>
        Eligibility Guidelines
      </section>
      <Paper className={classes.paper}>
        {version === 2 ? (
          <>
            <Typography variant="body1" paragraph={true}>
              The following guidelines have been established to ensure fairness to all Boys Town Program Graduates seeking continued support after
              high school graduation:
            </Typography>
            <Typography variant="body1" paragraph={true} component="div">
              <ul>
                <li>
                  All applicants must have been a resident of the Home Campus at Boys Town, Nebraska, or under the care of one of Boys Town's
                  affiliate campuses
                </li>
              </ul>
            </Typography>
            <Typography variant="body1" paragraph={true} component="div">
              <div style={{ marginBottom: '16px' }}>All applicants must:</div>
              <ul>
                <li>
                  Be graduates of Boys Town High School and/or lived at a Boys Town campus for a minimum of 6 months with a successful departure from
                  the Family Home Program
                </li>
                <li>Be in good standing with Boys Town</li>
                <li>
                  Submit a fully completed application, including an electronic signature. Incomplete or unsigned applications will not be considered.
                </li>
                <li>
                  Applicants for Scholarships and Successful Futures Community Supports must request and receive at least two recommendations from
                  Boys Town staff who are not in direct care (i.e., Family Teachers, Senior Assistant Family Teachers, Assistant Family Teachers,
                  Successful Futures Staff).
                </li>
                <li>
                  Applicants for Successful Futures Housing must request and receive at least three recommendations, two of which must come from
                  Family Home Program leadership—specifically individuals in director-level roles or higher
                </li>
              </ul>
            </Typography>
          </>
        ) : (
          <>
            <Typography variant="body1" paragraph={true}>
              To ensure the continuation of providing educational assistance to Boys Town Program Graduates, the following guidelines have been
              established to ensure fairness to all applicants.
            </Typography>
            <Typography variant="body1" paragraph={true} component="div">
              All applicants must have been a resident of the Home Campus at Boys Town, Nebraska, or under the care of one of Boys Town's satellite
              campuses, and meet the following criteria:
              <ul>
                <li>Graduated from Boys Town High School and/or;</li>
                <li>Lived at a Boys Town campus for a minimum of 6 months and departed the Family Home Program successfully.</li>
              </ul>
            </Typography>
            <Typography variant="body1" paragraph={true} component="div">
              All applicants must:
              <ul>
                <li>Be in good standing with Boys Town.</li>
                <li>If applying for an academic scholarship, you must attend an accredited institution of higher learning.</li>
                <li>Complete, in full, the application below. All applications must be electronically signed or will be deemed incomplete.</li>
                <li>Have and maintain a minimum of a 2.0 overall GPA in a 4.0 grading system or the equivalent in an alternate grading system.</li>
                <li>
                  All scholarship monies will be paid directly to the school to which the applicant is attending. Only in extraordinary circumstances
                  and with board approval will monies be paid directly to an applicant.
                </li>
              </ul>
            </Typography>
          </>
        )}
      </Paper>
    </Grid>
  );
};

Instructions.propTypes = {
  classes: PropTypes.object.isRequired,
  version: PropTypes.number,
};

export default Instructions;
